// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/elt-emergency-use-and-overdue.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/elt-emergency-use-and-overdue/elt-emergency-use-and-overdue.js';

mount([g0]);
